import { createContext, useContext } from "react";

// Lets an admin preview the app as a lower role. `realRole` is the logged-in
// user's actual role; `viewRole` is the role currently being previewed (null =
// no override). The EFFECTIVE role (used for nav + route guards) is
// viewRole || realRole. Only a real admin may set viewRole.
export const ViewAsContext = createContext({
  realRole: null,
  viewRole: null,
  effectiveRole: null,
  setViewRole: () => {},
});

export const useViewAs = () => useContext(ViewAsContext);
